import React, { useState } from "react";
import { loginApi } from "../../utils/api"; 

const Icons = {
  // ... (Keep your existing icons here)
  Eye: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>,
  EyeOff: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
};

export default function LoginForm({ handleAuthSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); 
  const [loading, setLoading] = useState(false);
  
  // ✅ NEW: Local error state just for this form
  const [localError, setLocalError] = useState("");

  const loginWithEmail = async (e) => {
    e.preventDefault();
    setLocalError(""); // Clear previous errors
    
    if (!email || !password) {
      return setLocalError("Please enter your email and password.");
    }
    
    setLoading(true);
    try {
      const data = await loginApi(email, password);
      handleAuthSuccess(data);
    } catch (err) {
      // ✅ Set the error locally so it shows inside the form!
      setLocalError(err.response?.data?.message || "Wrong email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="gpt-form-wrapper">
      <form onSubmit={loginWithEmail} className="gpt-fade-in">
        
        {/* ✅ INLINE ERROR MESSAGE BOX */}
        {localError && (
          <div style={{
            backgroundColor: "#FCE8E6",
            color: "#D93025",
            padding: "10px 14px",
            borderRadius: "8px",
            fontSize: "14px",
            marginBottom: "16px",
            border: "1px solid #FAD2CF",
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}>
            <span>⚠️</span> {localError}
          </div>
        )}

        <div className="gpt-input-group">
          <label>Email address</label>
          <input 
            type="email" 
            value={email} 
            onChange={(e) => {
               setEmail(e.target.value);
               setLocalError(""); // Clear error when user starts typing again
            }} 
            required 
            autoFocus
          />
        </div>

        <div className="gpt-input-group">
          <label>Password</label>
          <div className="password-wrapper">
            <input 
              type={showPassword ? "text" : "password"} 
              value={password} 
              onChange={(e) => {
                 setPassword(e.target.value);
                 setLocalError(""); // Clear error when user starts typing again
              }} 
              required 
            />
            <button 
              type="button" 
              className="eye-toggle-btn" 
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <Icons.EyeOff /> : <Icons.Eye />}
            </button>
          </div>
        </div>

        <div className="gpt-form-options">
          <button type="button" className="gpt-forgot-link">Forgot password?</button>
        </div>

        <button type="submit" className="gpt-primary-btn" disabled={loading}>
          {loading ? <span className="btn-spinner"></span> : "Log in"}
        </button>
      </form>
    </div>
  );
}